import { Container, Htag, HtagAlign, HtagVariant } from '../../components';
import styles from './logistic-service.module.css';

export default function LogisticService() {
  return (
    <div className={styles.root}>
      <Container>
        <Htag
          variant={HtagVariant.h2}
          align={HtagAlign.center}
          className={styles.title}
          tag="h2"
        >
          IT Services for Logistics We Offer
        </Htag>
        <p className={styles.description}>
          Logistics Software Development Services that we offer cover all sides
          of industry processes and boost business
        </p>
        <ul className={styles.list}>
          <li className={styles.item}>
            <div className={styles.card}>
              <h5 className={styles.card_title}>Сut Fleet Operational Costs</h5>
              <p className={styles.card_text}>
                Lowering costs by a more clever usage of the fleet, accurate
                tracking and better logistics logic. Software development will
                minimize your budget.
              </p>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.card}>
              <h5 className={styles.card_title}>Minimize Traffic Congestion</h5>
              <p className={styles.card_text}>
                Gathering and analyzing environmental data to reduce traffic
                congestion thus making it safer and smoother as well as speed up
                the delivery.
              </p>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.card}>
              <h5 className={styles.card_title}>Optimize Logistics Routes</h5>
              <p className={styles.card_text}>
                Recording and analyzing delivery and transit routes to improve
                planning, service and reduce people labor and energy wastes.
              </p>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.card}>
              <h5 className={styles.card_title}>Mapping & Navigation</h5>
              <p className={styles.card_text}>
                sing GIS, mapping services and APIs to visualize all
                transportation tasks on a map and make better and more intuitive
                UI/UX.
              </p>
            </div>
          </li>
        </ul>
      </Container>
    </div>
  );
}
